<template>
    <div>
        <v-btn @click="send()">test Electron Ja </v-btn>
    
        <div id="test">{{ data}}</div>

        <v-textarea label="Label" v-model="textja"></v-textarea>
    </div>

</template>

<script>
 window.addEventListener('message', (event) => {
    console.log('test from electron ????? ')
    console.log('event voiiii :' , event.data)
    //   if (event.data && event.data.message) {
    //     console.log('Received message from main process:', event.data.message);

    //     // Send a response back to the main process
    //     // window.postMessage({ response: 'Message received by web page' }, '*');
    //   }
    });
// import { useIpcRenderer } from '@vueuse/electron'

// enable nodeIntegration if you don't provide ipcRenderer explicitly
// @see: https://www.electronjs.org/docs/api/webview-tag#nodeintegration
// const ipcRenderer = useIpcRenderer()

// Ref result will return
// const result = ipcRenderer.invoke('custom-channel', 'some data')
// const msg = computed(() => result)

// remove listener automatically on unmounted
// ipcRenderer.on('custom-event', (event, ...args) => {
//   console.log(args)
// })
export default {
    data(){
        return{
            data: '',
            textja: ''
        }
    },
    mounted(){
        this.data = 'testja'
    },
    watch:{
        data(){
            console.log('data : ',this.data)
        }
    },
    methods:{
        send(){
            // window.postMessage('Hello from the web page!', '*');
            console.log('Snipper')
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/testurl.vue